import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Drawer, IconButton, Typography, useTheme } from '@mui/material';
import { ArrowDown2 } from 'iconsax-react';
import { useBDrawerStyles } from './useBDrawerStyles';
const BDrawer = ({ children, showCloseButton = true, showTopBar = true, showBottomBar = true, title, onClose, anchor = 'bottom', dialogActions, showClearFilterButton, handleClearFilter, filterLabel, fullHeight = false, ...drawerProps }) => {
    const theme = useTheme();
    const styles = useBDrawerStyles(fullHeight);
    const handleCloseClick = () => {
        if (onClose) {
            onClose({}, 'backdropClick');
        }
    };
    return (_jsxs(Drawer, { ...drawerProps, anchor: anchor, onClose: onClose, PaperProps: {
            ...drawerProps.PaperProps,
            sx: [
                styles.drawerPaper,
                ...(drawerProps.PaperProps?.sx
                    ? Array.isArray(drawerProps.PaperProps.sx)
                        ? drawerProps.PaperProps.sx
                        : [drawerProps.PaperProps.sx]
                    : [])
            ]
        }, children: [showTopBar && (_jsx(Box, { sx: styles.topBar, children: _jsx(Box, { sx: styles.indicator }) })), _jsxs(Box, { sx: title ? styles.headerContainer : styles.headerContainerCentered, children: [_jsx(Typography, { variant: 'h4', color: 'text.primary', children: title }), _jsxs(Box, { display: 'flex', gap: 1, alignItems: 'center', children: [showClearFilterButton && (_jsx(Button, { size: 'large', onClick: handleClearFilter, variant: 'outlined', children: filterLabel })), showCloseButton && (_jsx(IconButton, { onClick: handleCloseClick, sx: styles.closeButton, size: 'small', children: _jsx(ArrowDown2, { size: 20 }) }))] })] }), _jsx(Box, { sx: showBottomBar ? styles.contentContainer : styles.contentWithBottomPadding, children: children }), dialogActions && (_jsx(Box, { sx: {
                    width: '100%',
                    padding: theme.spacing(1),
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: theme.spacing(1.5)
                }, children: dialogActions }))] }));
};
export default BDrawer;
